<template>
  <v-layout pl-2 pt-2 pr-2 pb-2 justify-center row>
    <v-flex xs12>
      <v-layout row wrap align-content-center justify-center>
        <v-flex xs12>
          <v-card>
            <v-toolbar color="primary" dark>
              <v-toolbar-title>Loyalty Tiers</v-toolbar-title>
              <v-divider class="mx-3" inset vertical></v-divider>
              <p>One tier must have a point threshold of 0. This is the 'starter' tier</p>
              <v-spacer></v-spacer>
              <v-btn icon @click="$router.push('/settings/loyalty/loyalty_tiers/create')">
                <v-icon>add</v-icon>
              </v-btn>
            </v-toolbar>
            <LoyaltyTierList
              v-if="!loading"
              style="width: 100%;"
              :loyaltyTiers="loyalty_tiers"
              @orderChange="changeLoyaltyTierOrder($event)"
              @edit="editLoyaltyTier($event)"
            ></LoyaltyTierList>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-snackbar v-model="snackbarShow" :color="snackbarColour" :timeout="4000">
      <v-layout align-center justify-center>{{ snackbarMessage }}</v-layout>
    </v-snackbar>
  </v-layout>
</template>

<script>
import SimpleCard from "@/components/widget/SimpleCard.vue";
import LoyaltyTierList from "@/components/settings/loyalty/LoyaltyTierList.vue";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "loyalty_tiers",
  components: {
    SimpleCard,
    LoyaltyTierList
  },
  data: function() {
    return {
      loyalty_tiers: [],
      loading: true,
      snackbarShow: false,
      snackbarMessage: null,
      snackbarColour: null
    };
  },
  mounted: async function() {
    this.getLoyaltyTiers();
    this.loading = false;
  },
  methods: {
    getLoyaltyTiers: async function() {
      try {
        let url = `${this.$store.state.apiUrl}/settings/loyalty_tiers/getAll`;

        let response = await axios.get(url, {
          params: {}
        });
        let loyaltyTiers = response.data.loyalty_tiers;

        loyaltyTiers.sort(function(a, b) {
          return a.point_threshold - b.point_threshold;
        });

        this.loyalty_tiers = loyaltyTiers;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log("Failed to get loyalty tiers " + error);
      }
    },
    showSnackbar: function(message, colour) {
      this.snackbarMessage = message;
      this.snackbarColour = colour;
      this.snackbarShow = true;
    },
    editLoyaltyTier: function(id) {
      console.log("Launching edit loyalty tier");
      this.$router.push("/settings/loyalty_tiers/edit/" + id);
    }
  }
};
</script>

<style>
.nobold {
  font-weight: normal;
}

#make-small {
  transform: scale(0.8);
  transform-origin: left;
}
.make-small {
  transform: scale(0.8);
  transform-origin: left;
}
</style>